var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 41 41","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M36.056-.006l4.95 4.95L4.944 41.006l-4.95-4.95z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M-.006 4.944l4.95-4.95 36.062 36.062-4.95 4.95z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb4ac28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svgs/CloseButton.vue
// module id = null
// module chunks = 